<template>
  <div>
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-card class="margin-bottom">
          <template slot="title">
            <status
              :status="
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].status
                  : null
              "
              v-if="getScreen"
            />
            <h4 class="margin-remove">
              {{ getManifestSC.jenis == "Approve" ? "APPROVAL" : "MANIFEST" }}
              SALES CONTRACT
              <status
                :status="
                  getManifestSC.header_1
                    ? getManifestSC.header_1[0].status
                    : null
                "
                v-if="!getScreen"
              />
            </h4>
            <small>{{
              getManifestSC.header_1
                ? getManifestSC.header_1[0].no_sales_contract
                : "-"
            }}</small>
          </template>
          <a-popover slot="extra" trigger="click" placement="bottom">
            <span slot="title">Select Action</span>
            <ul class="m-list-wrapper bordered" slot="content">
              <li>
                <a-button
                  @click="handlePrintManifest"
                  type="dashed"
                  icon="printer"
                  block
                  class="m-display-block"
                  :loading="printLoad.manifest"
                  >Manifest</a-button
                >
              </li>
              <li>
                <a-button-group>
                  <a-button
                    :disabled="getManifestSC.edit_sts == '0'"
                    type="dashed"
                    icon="edit"
                    @click="handleEdit"
                    >Edit</a-button
                  >
                  <a-button
                    type="dashed"
                    :disabled="getManifestSC.cancel_sts == '0'"
                    :loading="cancel_loading"
                    @click="handlecanceltrans"
                    icon="close-square"
                  >
                    Cancel
                  </a-button>
                  <a-button
                    :disabled="getManifestSC.close_sts == '0'"
                    type="dashed"
                    @click="handleclosetrans"
                    icon="close"
                  >
                    Close
                  </a-button>
                </a-button-group>
              </li>
            </ul>
            <a-button :size="getScreen ? 'small' : 'default'" icon="more">{{getScreen ? '' : 'Action'}}</a-button>
          </a-popover>
          <ul class="m-list-wrapper bordered">
            <li>
              <span class="m-list-title">Create Date</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? moment(getManifestSC.header_1[0].create_dt).format(
                      getDefaultDateFormat
                    )
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">Contract Date</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1 ? getManifestSC.header_1[0].tanggal : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">User Creator</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].tlc_create
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">Code Cost Center</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1 ? getManifestSC.header_1[0].kode : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">contract no</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].contract_no
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">sktd ppn no</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].sktd_ppn_no
                  : "-"
              }}</span>
            </li>
            <!-- <li>
              <span class="m-list-title">Budget Operation Authority</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1 ? getManifestSC.header_1[0].pimpro : "-"
              }}</span>
            </li> -->
            <li>
              <span class="m-list-title">Contract Period</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1 ? getManifestSC.header_1[0].periode : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">invoice to</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].invoice_to
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">customer</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].customer
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">Contract Name</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].description
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title">Nomor Amandemen</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].amandemen_no
                  : "-"
              }}</span>
            </li>
            <!-- <li>
              <span class="m-list-title">note</span>
              <span class="m-list-desc">{{
                getManifestSC.header_1
                  ? getManifestSC.header_1[0].note
                  : "-"
              }}</span>
            </li> -->
          </ul>
        </a-card>
        <a-card class="margin-bottom">
          <ul class="m-list-wrapper bordered">
            <li>
              <span class="m-list-title">BANK ACCOUNT</span>
              <span class="m-list-desc">{{
                getManifestSC.header_2
                  ? getManifestSC.header_2[0].bank_account
                    ? getManifestSC.header_2[0].bank_account
                    : "-"
                  : "-"
              }}</span>
            </li>
            <!-- <li>
              <span class="m-list-title">project currency</span>
              <span class="m-list-desc">{{
                getManifestSC.header_2
                  ? getManifestSC.header_2[0].project_currency
                  : "-"
              }}</span>
            </li>
            <li>
              <span class="m-list-title"
                >Exchange Rate 1.00 {{ getManifestSC.header_2 ? getManifestSC.header_2[0].currency:'-' }} to
                IDR</span
              >
              <span class="m-list-desc">{{
                getManifestSC.header_2
                  ? getManifestSC.header_2[0].project_currency
                  : "-"
              }}</span>
            </li> -->
            <li>
              <span class="m-list-title">project value</span>
              <span class="m-list-desc">{{
                formatCurrency(
                  getManifestSC.header_2
                    ? getManifestSC.header_2[0].currency
                    : "IDR",
                  getManifestSC.header_2
                    ? getManifestSC.header_2[0].project_value
                    : 0
                )
              }}</span>
            </li>
            <li>
              <a-row :gutter="12">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <span class="m-list-title">PPN</span>
                  <span class="m-list-desc">{{
                    getManifestSC.header_2
                      ? getManifestSC.header_2[0].include_ppn
                      : "-"
                  }}</span>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <span class="m-list-title">PPN Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency(
                      getManifestSC.header_2
                        ? getManifestSC.header_2[0].currency
                        : "IDR",
                      getManifestSC.header_2
                        ? getManifestSC.header_2[0].ppn_value
                        : 0
                    )
                  }}</span>
                </a-col>
              </a-row>
            </li>
            <li>
              <span class="m-list-title">remaining balance</span>
              <span class="m-list-desc">{{
                formatCurrency(
                  getManifestSC.header_2
                    ? getManifestSC.header_2[0].currency
                    : "IDR",
                  getManifestSC.header_3
                    ? getManifestSC.header_3[0].remaining_balance
                    : 0
                )
              }}</span>
            </li>
          </ul>
        </a-card>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Detail Termin</h4>
            </div>
            <a-table
              size="small"
              bordered
              rowKey="id_sc_dtl_invoice"
              :columns="columns"
              :data-source="getManifestSC.header_5"
              :scroll="{ x: 800 }"
            >
              <span slot="qtyunit" slot-scope="item">
                {{ item.qty }} / {{item.unit}}
              </span>
              <span slot="no" slot-scope="item, record, index">
                {{ index + 1 }}
              </span>
              <span slot="periode" slot-scope="item">
                  {{ moment(item.periode).format("YYYY-MM") }}
                </span>
              <span slot="no_invoice" slot-scope="item">
                <span v-if="!item.id_ar_sales_contract">{{
                  item.no_invoice
                }}</span>
                <a
                  v-else
                  @click="handleLinkInvoice(item.id_ar_sales_contract)"
                  >{{ item.no_invoice }}</a
                >
              </span>
              <span slot="doc_release" slot-scope="item">
                <a-button
                  type="primary"
                  icon="eye"
                  @click="handleViewDoc(item)"
                >View</a-button>
              </span>
              <span slot="value" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.unit_price"
                />
              </span>
              <span slot="remaining_balance" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.remaining_balance"
                />
              </span>
              <span slot="ppn_sktd" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.ppn_sktd"
                />
              </span>
              <span slot="ppn_dipungut" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.ppn_dipungut"
                />
              </span>
              <span slot="ppn_memungut" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.ppn_memungut"
                />
              </span>
              <span slot="ppn_migas" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.ppn_migas"
                />
              </span>
              <span slot="pph22_15" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.pph22_15"
                />
              </span>
              <span slot="fee_lain" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.fee_lain"
                />
              </span>
              <span slot="taktis" slot-scope="item, record">
                <CurrencyJustified
                  :currencyValue="record.currency"
                  :valueNumber="item.taktis"
                />
              </span>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Dokumen Pendukung</h4>
            </div>
            <a-list
              itemLayout="horizontal"
              :dataSource="getManifestSC.data_pendukung"
            >
              <Empty
                v-if="
                  getManifestSC.data_pendukung
                    ? getManifestSC.data_pendukung.length <= 0
                    : getManifestSC.data_pendukung
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle"
                  >
                    <h4 class="m-list-dots margin-remove">
                      {{ item.nama_file }}
                    </h4>
                    <a-button
                      size="small"
                      type="default"
                      icon="cloud-download"
                      @click="handleDownload(item.path)"
                    ></a-button>
                  </div>
                  <p
                    slot="description"
                    class="margin-remove"
                    :class="getScreen ? 'm-list-dots' : ''"
                  >
                    {{ item.desc }}
                  </p>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Related Document</h4>
            </div>

            <a-list
              itemLayout="horizontal"
              :dataSource="getManifestSC.related_dokumen"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle"
                  >
                    <a @click="handleViewProcess(item)"
                      >{{ item.header }} | {{ item.user_pembuat }}</a
                    >
                    <Status
                      :class="!getScreen ? 'margin-remove' : ''"
                      :status="item.status"
                    />
                  </div>
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle"
                    v-if="item.no_trans"
                  >
                    <span>{{ item.no_trans }}</span>
                  </div>
                  <div slot="description">
                    <div class="m-width-full">
                      <a-tooltip
                        class="ant-tooltip-inner"
                        placement="top"
                        :title="
                          item.deskripsi
                            ? item.deskripsi
                            : 'Tidak ada deskripsi'
                        "
                      >
                        <span class="ant-description-ellipses">{{
                          item.deskripsi
                            ? item.deskripsi
                            : "Tidak ada deskripsi"
                        }}</span>
                      </a-tooltip>
                      <span v-if="item.rest_api!='sales_notification'">{{ formatCurrency("IDR", item.value) }}</span>
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>

        <a-card class="margin-top" title="History Amandemen">
          <a-list itemLayout="horizontal" :dataSource="getManifestSC.history_amandemen">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between align-middle">
                  <span>Amandemen ke : {{item.amandemen_ke}}</span>
                  <a-button type="link" @click="handleHistory(item)">View History</a-button>
                </div>
                <div slot="description">
                  {{item.to_char + ' | ' + item.tlc_last_update}}
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>

      <a-modal
        centered
        v-model="visibleHistory"
        @ok="historyToggle"
        :footer="null"
      >
        <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

        <ul class="m-list-wrapper bordered">
          <li
            v-for="history in getManifestSC.status_transaksi
              ? getManifestSC.status_transaksi[0].history
              : []"
            :key="history.id_notifikasi"
          >
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }} | {{ history.tlc_to }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
    </a-row>
    <a-row v-if="getManifestSC.jenis == 'Approve'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-card class="margin-top" title="Manifest Action">
          <a-form-model ref="actionForm" :rules="rules" :model="form">
            <a-form-model-item label="Note" prop="note">
              <a-textarea v-model="form.note" :row="2"></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="Actions" prop="action">
              <a-select showSearch v-model="form.action">
                <a-select-option
                  v-for="item in getManifestSC.aksi"
                  :key="item.aksi"
                  >{{ item.aksi }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-form-model>
          <div class="action">
            <a-button
              :loading="loading"
              @click="handleSave()"
              type="primary"
              icon="save"
            >
              Save
            </a-button>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-modal
      v-model="mv_doc"
      :maskClosable="false"
      @cancel="handleCloseView"
      :footer="null"
    >
      <span slot="title">
        <a-icon type="download" class="margin-right" />Supporting Document
      </span>
      <a-card>
        <a-list itemLayout="horizontal" :dataSource="filesupportSC" :loading="loadingviewdoc">
          <Empty
            v-if="filesupportSC.length==0"
          />
          <a-list-item slot="renderItem" slot-scope="data">
            <a-list-item-meta>
              <div slot="title" class="m-display-flex space-between align-middle">
                <h4 class="m-list-dots margin-removes">{{data.document_desc}}</h4>
                <a-button
                  size="default"
                  type="primary"
                  icon="cloud-download"
                  @click="handleDownload(data.path)"
                ></a-button>
              </div>
              <div slot="description">
                <span>{{data.document_nm}}</span>
              </div>
              <div slot="avatar" >
                <a-icon :type="load_icon(data.path ? 
                  data.path.substring(data.path.lastIndexOf('.')+1) 
                    : 'file')" style='font-size: 48px'/>
              </div>
              <!-- <img v-if="data.file_attachment_url && data.file_attachment_url.includes('.pdf')" class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" /> -->
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "manifest-sales-contract",
  props: {
    id: String,
    tlc_pembuat: String,
  },
  components: { Status },
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    const columns = [
      {
        title: "No",
        width: 25,
        key: "no",
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Termin Period",
        key: "periode",
        scopedSlots: { customRender: "periode" },
        width: 70,
      },
      {
        title: "Termin Description",
        key: "workname",
        dataIndex: "work_nm",
        width: 100,
      },
      {
        title: "QTY / Unit",
        key: "qtyunit",
        align: "right",
        width: 90,
        scopedSlots: { customRender: "qtyunit" },
      },
      {
        title: "Unit Price",
        key: "unit_price",
        align: "right",
        width: 90,
        scopedSlots: { customRender: "value" },
      },
      // {
      //   title: "No Invoice",
      //   key: "no_invoice",
      //   width: 100,
      //   scopedSlots: { customRender: "no_invoice" },
      // },
      // {
      //   title: "Addendum(AR) of",
      //   key: "addendum_ke",
      //   dataIndex: "addendum_ke",
      //   width: 100,
      // },
      // {
      //   title: "View Document Release",
      //   key: "doc_release",
      //   scopedSlots: { customRender: "doc_release" },
      //   align: "center",
      //   width: 100,
      // },
      // {
      //   title: "No. BKM",
      //   key: "no_bkm",
      //   dataIndex: "no_bkm",
      //   width: 100,
      // },
      {
        title: "Remaining balance",
        key: "remaining_balance",
        align: "right",
        width: 90,
        scopedSlots: { customRender: "remaining_balance" },
      },
    ];
    const dp_columns = [
      {
        title: "Product/Work",
        dataIndex: "product_nm",
        key: "product_nm",
        width: 200,
      },
      {
        title: "PN",
        dataIndex: "product_pn",
        key: "pn",
        width: 150,
      },
      {
        title: "Note",
        dataIndex: "note",
        key: "note",
        width: 200,
      },
      {
        title: "QTY",
        dataIndex: "qty",
        key: "qty",
        width: 100,
      },
      {
        title: "Unit Price",
        dataIndex: "unit_price",
        key: "unit_price",
        align: "right",
        scopedSlots: { customRender: "unitprice" },
        width: 150,
      },
      {
        title: "Total Price",
        key: "total_price",
        align: "right",
        scopedSlots: { customRender: "totalprice" },
        width: 150,
      },
    ];
    return {
      columns,
      dp_columns,
      visibleHistory: false,
      loading: false,
      cancel_loading: false,
      close_loading: false,
      form: {
        note: "",
        action: "",
      },
      rules: {
        action: [
          {
            required: true,
            message: "Please select action type",
            trigger: "change",
          },
        ],
      },
      printLoad: {
        manifest: false,
      },
      mv_doc : false,
      loadingviewdoc: false,
      filesupportSC: [],
    };
  },
  watch: {
    id() {
      this.fetch();
    },
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getManifestSC",
      "getDefaultDateFormat",
    ]),
  },
  methods: {
    moment,
    fetch() {
      this.$store.dispatch("getManifestSC", {
        auth: this.getAuth,
        params: { id: this.id, },
      });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item, "_blank");
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    submit() {
      if (
        this.$refs.actionForm.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

          this.loading = true;

          const data = {
            id_sales_contract: this.id,
            tlc: this.getAuth.username,
            status: this.form.action,
            remark: this.form.note,
          };

          this.$store
            .dispatch("postManifestSC", {
              auth: this.getAuth,
              payload: data,
            })
            .then((res) => {
              this.loading = false;
              this.displayMessage("success-save");
              this.$router.go();
            })
            .catch((err) => {
              this.loading = false;
              this.displayMessageCustom(
                "warning-form-message",
                err.response.data.message
              );
            });
        })
      );
    },
    handleSave() {
      this.confirmMessage("confirm-save");
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      this.$store
        .dispatch("printManifestSC", {
          auth: this.getAuth,
          params: this.id,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editSalesContract",
        params: { id: this.id },
      });
    },
    handleclosetrans() {
      const data = {
        id_manifest: this.getManifestSC.header_1[0].id_sales_contract,
        tlc: this.getAuth.username,
        code_trans: this.getManifestSC.header_1[0].no_sales_contract,
        kode_project: this.getManifestSC.header_1[0].kode,
      };

      this.close_loading = true;
      this.$store
        .dispatch("closeTransactionSC", {
          auth: this.getAuth,
          payload: data,
        })
        .then((res) => {
          this.displayMessageValue(
            "successCancel",
            "Transaction has been closed"
          );
          this.$router.go();
          this.close_loading = false;
        })
        .catch((err) => {
          this.close_loading = false;
        });
    },
    handlecanceltrans() {
      const data = {
        jenis_trans: "sales_contract",
        id_manifest: this.getManifestSC.header_1[0].id_sales_contract,
        tlc: this.getAuth.username,
        code_trans: this.getManifestSC.header_1[0].no_sales_contract,
        kode_project: this.getManifestSC.header_1[0].kode,
      };

      this.cancel_loading = true;
      this.$store
        .dispatch("cancelTransactionSC", {
          auth: this.getAuth,
          payload: data,
        })
        .then((res) => {
          this.displayMessageValue(
            "successCancel",
            "Transaction has been cancelled"
          );
          this.$router.go();
          this.cancel_loading = false;
        })
        .catch((err) => {
          this.cancel_loading = false;
        });
    },
    handleLinkInvoice(id) {
      this.$router.push({
        name: "account-receive-manifest",
        params: { id: id, tab: "release", jns: "Penerimaan_Kontrak" },
      });
    },
    handleHistory(item){
      const url = this.$router.resolve({name: "manifestSalesContractHistory", params: {id_ : item.id}})
      window.open(url.href, '_blank')
    },
    handleViewDoc(val){
      this.loadingviewdoc = true;
      this.mv_doc = true;
      this.$store.dispatch("getSupportDocSC", {
        auth: this.getAuth,
        id: val.id_termin_release,
      })
      .then((response) => {
          this.filesupportSC = response.data.data_doc;
          // this.displayMessageValue("success-other", response.message);
          // this.$router.push({ name: "account-receive-index" });
          this.loadingviewdoc = false;
      })
      .catch((error) => {
        console.log();
        this.loadingviewdoc = false;
        this.mv_doc = false;
        let responses = Object.assign({}, error);
        console.log(responses);
        if (responses.data) {
          this.displayMessageValue("error-other", responses.data.message);
        } else {
          this.displayMessageValue("error-other", responses.response);
        }
      });

    },
    handleCloseView(){
      this.mv_doc = false;
      this.filesupportSC = [];
    },
    handleViewProcess(item){
      item.sebagai = this.getAuth.divisi[0];
      item.id_manifest = item.id;
      this.handleView(item);
    }
  },
  mounted() {
    this.fetch();
  },
  created() {
    this.fetch();
  },
};
</script>

<style lang="less" scoped>
.action {
  border-top: 1px solid darken(white, 10);
  height: 50px;
  margin-top: @margin;
  padding: @padding 0;
}
</style>
